import { useEffect } from 'react';

import { useSessionStore } from '../../stores';
import NotFound from './NotFound';

function TestError() {
  useEffect(() => {
    const isAuthenticated = useSessionStore.getState().isAuthenticated;
    const hostName = window.location.hostname;
    const isDevTest = hostName.includes('.uat.') || hostName.includes('.dev.') || hostName.includes('.local.');
    if (isAuthenticated && isDevTest) {
      throw new Error('Test error');
    }
  }, []);

  return <NotFound />;
}

export default TestError;
